<template>
  <section class="integrity-block-view">
    <header class="integrity-block-view__header">
      <p class="integrity-block-view__eyebrow">Trust control</p>
      <h4 class="integrity-block-view__title">Answer blocked pending evidence review</h4>
      <p class="integrity-block-view__summary">{{ answer }}</p>
    </header>

    <section v-if="limitations.length" class="integrity-block-view__card">
      <p class="integrity-block-view__label">Why this was blocked</p>
      <ul class="integrity-block-view__list">
        <li v-for="(limitation, index) in limitations" :key="`blocked-limitation-${index}`">
          {{ limitation }}
        </li>
      </ul>
    </section>

    <section v-if="datasetContextItems.length" class="integrity-block-view__card">
      <p class="integrity-block-view__label">Dataset context</p>
      <dl class="integrity-block-view__pairs">
        <div
          v-for="item in datasetContextItems"
          :key="`blocked-context-${item.label}`"
          class="integrity-block-view__pair"
        >
          <dt>{{ item.label }}</dt>
          <dd>{{ item.value }}</dd>
        </div>
      </dl>
    </section>
  </section>
</template>

<script>
export default {
  name: 'IntegrityBlockView',
  props: {
    answer: {
      type: String,
      default: '',
    },
    limitations: {
      type: Array,
      default: () => [],
    },
    datasetContextItems: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.integrity-block-view {
  display: flex;
  flex-direction: column;
  gap: $space-4;
}

.integrity-block-view__header,
.integrity-block-view__card {
  border: 1px solid rgba($color-danger, 0.25);
  border-radius: $radius-md;
  background: rgba($color-danger, 0.04);
  padding: $space-3;
}

.integrity-block-view__eyebrow,
.integrity-block-view__label,
.integrity-block-view__pair dt {
  margin: 0 0 $space-1;
  font-size: $font-size-xs;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: $color-danger;
}

.integrity-block-view__title,
.integrity-block-view__summary {
  margin: 0;
}

.integrity-block-view__summary {
  margin-top: $space-2;
}

.integrity-block-view__list {
  margin: 0;
  padding-left: 1.2rem;
}

.integrity-block-view__list li + li {
  margin-top: $space-2;
}

.integrity-block-view__pairs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: $space-3;
  margin: 0;
}

.integrity-block-view__pair {
  display: flex;
  flex-direction: column;
  gap: $space-1;
}

.integrity-block-view__pair dd {
  margin: 0;
}
</style>
